var map = {
	"./Adobe.png": 5804,
	"./Amazon.png": 2921,
	"./Apple.png": 8941,
	"./Google.png": 548,
	"./Meta.png": 8402,
	"./Microsoft.png": 233,
	"./Netflix.png": 8149,
	"./Spotify.png": 8371
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7146;